import React from 'react';
import { CheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-8 md:py-12 border-b border-gray-200" data-id="element-21">
      <h2 className="text-xl md:text-3xl font-bold text-center mb-6 md:mb-8" data-id="element-22">
        100% Satisfaction Guarantee
      </h2>
      <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-23">
        <div className="w-full md:w-1/3 flex justify-center" data-id="element-24">
          <div className="bg-blue-50 rounded-full p-6 md:p-8 w-36 h-36 md:w-48 md:h-48 flex items-center justify-center" data-id="element-25">
            <div className="text-center" data-id="element-26">
              <div className="text-blue-700 font-bold text-lg md:text-xl" data-id="element-27">
                90-DAY
              </div>
              <div className="text-blue-700 font-bold text-base md:text-lg" data-id="element-28">
                MONEY-BACK
              </div>
              <div className="text-blue-700 font-bold text-base md:text-lg" data-id="element-29">
                GUARANTEE
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-2/3 mt-4 md:mt-0" data-id="element-30">
          <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4" data-id="element-31">
            We do ALL the testing, so you don't have to
          </h3>
          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-32">
            <li className="flex items-start" data-id="element-33">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 md:mr-3 mt-1 flex-shrink-0" data-id="element-34" />
              <span className="text-sm md:text-base" data-id="element-35">
                Made in FDA-registered facility
              </span>
            </li>
            <li className="flex items-start" data-id="element-36">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 md:mr-3 mt-1 flex-shrink-0" data-id="element-37" />
              <span className="text-sm md:text-base" data-id="element-38">
                Third-party tested for purity
              </span>
            </li>
            <li className="flex items-start" data-id="element-39">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 md:mr-3 mt-1 flex-shrink-0" data-id="element-40" />
              <span className="text-sm md:text-base" data-id="element-41">
                90-day money-back guarantee
              </span>
            </li>
            <li className="flex items-start" data-id="element-42">
              <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 md:mr-3 mt-1 flex-shrink-0" data-id="element-43" />
              <span className="text-sm md:text-base" data-id="element-44">
                No questions asked returns
              </span>
            </li>
          </ul>
          <p className="text-sm md:text-base text-gray-700 italic" data-id="element-45">
            If you don't feel warmer hands, better energy, and improved
            circulation in 90 days, return even empty bottles for full refund.
          </p>
        </div>
      </div>
    </section>;
}